import type { ProjectDto } from "@shared/types";
import type { UiMode } from "@shared/schemas";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { Badge, Button, Card, CardBody, PageHeader } from "./ui";

// Shown on home when the signed-in viewer is a member of more than one
// project — they need to pick which one to open. Single-project members
// auto-redirect (see `home.tsx`).
export function ProjectPicker({
  projects,
  uiMode,
}: {
  projects: ProjectDto[];
  uiMode: UiMode;
}) {
  return (
    <section class="space-y-6">
      <PageHeader
        title="プロジェクトを選択"
        description="あなたが所属するプロジェクトです。開きたいものを選んでください。"
      />
      <ul class="grid gap-3 sm:grid-cols-2">
        {projects.map((p) => {
          const href =
            uiMode === "simple" ? `/projects/${p.id}/pages` : `/projects/${p.id}`;
          return (
            <li key={p.id}>
              <Card>
                <CardBody class="space-y-3">
                  <div class="flex items-start justify-between gap-3">
                    <div class="min-w-0">
                      <div class="truncate text-base font-semibold text-fg">
                        {p.name}
                      </div>
                      <div class="truncate font-mono text-xs text-fg-subtle">
                        /{p.slug}
                      </div>
                    </div>
                    <Badge
                      tone={p.viewerRole === "owner" ? "warning" : "neutral"}
                    >
                      {p.viewerRole === "platform_admin"
                        ? "プラットフォーム管理者"
                        : p.viewerRole}
                    </Badge>
                  </div>
                  <Button
                    as="a"
                    href={href}
                    size="sm"
                    variant="secondary"
                    iconRight={<ArrowRightIcon class="h-3.5 w-3.5" />}
                  >
                    開く
                  </Button>
                </CardBody>
              </Card>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
